import { httpClient } from '@/core/api/http-client'
import type { Unit, UnitInput, UnitListParams } from '@/domain/entities/unit.entity'
import type { Paged } from '@/domain/entities/paging'
import type { UnitRepository } from '@/domain/repositories/unit.repository'
import { unwrap, unwrapPaged } from '@/infrastructure/shared/unwrap'
import type { UnitDto } from './unit.dto'
import { unitMapper } from './unit.mapper'

export class UnitHttpRepository implements UnitRepository {
  async list(outletId: string, params: UnitListParams): Promise<Paged<Unit>> {
    const raw = await httpClient.get<unknown>('/units', {
      params: {
        outlet_id: outletId,
        page: params.page,
        limit: params.limit,
        search: params.search || undefined,
      },
    })
    const paged = unwrapPaged<UnitDto>(raw, params.page, params.limit)
    return { ...paged, items: paged.items.map(unitMapper.toUnit) }
  }

  async create(outletId: string, input: UnitInput): Promise<Unit> {
    const raw = await httpClient.post<unknown>('/units', {
      outlet_id: outletId,
      ...unitMapper.toBody(input),
    })
    return unitMapper.toUnit(unwrap<UnitDto>(raw))
  }

  async update(id: string, input: UnitInput): Promise<Unit> {
    const raw = await httpClient.put<unknown>(`/units/${id}`, unitMapper.toBody(input))
    return unitMapper.toUnit(unwrap<UnitDto>(raw))
  }

  async remove(id: string): Promise<void> {
    // 422 Unprocessable Entity jika satuan masih dipakai bahan.
    // Error ditangkap di composable → toast error.
    await httpClient.delete(`/units/${id}`)
  }
}
